import dynamicTextUtilities from './dynamicTextUtilities'
import type { UpdateDynamicTextHandlerProps } from '@/types/editor'

export const updateHeaders = (
  dynamicTextProps: UpdateDynamicTextHandlerProps,
) => {
  const { elementProps } = dynamicTextProps
  const { element } = elementProps

  const { getHeader, updateDeepestSpanText } =
    dynamicTextUtilities(dynamicTextProps)

  const headerData = getHeader(element)

  if (!headerData) {
    return
  }

  const { value } = headerData as { value: string; path: string }

  updateDeepestSpanText(element, value)
}
